
import Button from './button';

interface ValidationAlertMessageProps {
    linkText: string
    fieldReference?: HTMLElement | null
    description: string
    componentHeading: string
}

const ValidationAlertMessage = (props: ValidationAlertMessageProps) => {
    return <>
        <div key={`${props.linkText}-key`}>
            <Button
                variation={'ghost'}
                analyticsData={{
                    text: props.linkText,
                    parentComponentHeading: props.componentHeading
                }}
                onClick={() => props.fieldReference?.focus()}
                style={{padding: 0}}
            >
                {props.linkText}
            </Button>: {props.description}
        </div>
    </>
};

export default ValidationAlertMessage;
